var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// P:/Work/htdocs/biatlon/online/~/react-scripts/~/core-js/library/modules/_html.js
// module id = 616
// module chunks = 0